// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturesTile_container__2A3LK","image":"FeaturesTile_image__3yIS9","header":"FeaturesTile_header__1y8bd","description":"FeaturesTile_description__3os3o"};